import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { Box } from '@honda-canada/design-system-react';
import { useAppSelector } from '../../core/utils';
import { paymentTabs } from '../PaymentOptions/constants';
import { selectCurrentVehicle } from '../../core/reducers/currentVehicle';
import { useFetchCurrentVehicleFinancialCalculatorPayment } from '../../core/apiHooks/useFetchPayment';
import PaymentOptions from '../PaymentOptions';
import { selectPaymentOptions } from '../../core/reducers/financialCalculators';
import { selectCurrentVehicleFromVehicles } from '../../core/reducers/vehicles';
const PaymentMethodOptions = ({ calculatorId, disableAllFields, onChange, }) => {
    const { overriddenIsSellingProvince, paymentMethod, paymentFrequency, includeFees } = useAppSelector(state => selectPaymentOptions(state, calculatorId));
    const { availablePaymentMethods } = useAppSelector(selectCurrentVehicleFromVehicles);
    const availablePaymentTabs = paymentTabs.filter(tab => availablePaymentMethods === null || availablePaymentMethods === void 0 ? void 0 : availablePaymentMethods.includes(tab.method));
    const activeTabIndex = availablePaymentTabs.findIndex(tab => tab.method === paymentMethod);
    const currentActiveTab = Math.max(activeTabIndex, 0);
    const { data: payment, isFetching, error } = useFetchCurrentVehicleFinancialCalculatorPayment(calculatorId);
    const currentVehicle = useAppSelector(selectCurrentVehicle);
    useEffect(() => {
        var _a;
        if (activeTabIndex >= 0)
            return;
        const firstAvailableMethod = (_a = availablePaymentTabs[0]) === null || _a === void 0 ? void 0 : _a.method;
        if (!onChange || !firstAvailableMethod)
            return;
        onChange(firstAvailableMethod);
    }, [activeTabIndex]);
    const onChangeActiveTab = (tabIndex) => {
        var _a;
        const selectedPaymentMethod = (_a = availablePaymentTabs[tabIndex]) === null || _a === void 0 ? void 0 : _a.method;
        if (onChange) {
            onChange(selectedPaymentMethod);
        }
    };
    return (_jsx(Box, { "data-testid": "cy-calculator-payment-options", children: _jsx(PaymentOptions, { ariaLabel: "trim-payment", onChangeActiveTab: onChangeActiveTab, activeTab: currentActiveTab, paymentMethod: paymentMethod, paymentFrequency: paymentFrequency, modelYear: currentVehicle.modelYear, payment: payment, isFetching: isFetching, error: error, overriddenIsSellingProvince: !!overriddenIsSellingProvince, includeFees: includeFees, disableAllFields: disableAllFields }) }));
};
export default PaymentMethodOptions;
